import { apiRequest } from 'src/utils/api-request';

export const sendLogToServer = (message: string, version: string) =>
  apiRequest<null>({
    path: '/log',
    body: { message, version },
    method: 'POST',
  });
